import {SETableColumnsProps} from "../../../../components/SETable";
import {Grid, IconButton} from "@mui/material";
import {RiCheckboxCircleFill, RiErrorWarningFill,} from "react-icons/ri";
import React from "react";
import {formatCPF} from "../../../../../utils/utils";
import {cnpjMask} from "../../../../../utils/mask";
import {formatDateToBR} from "../../../../../utils/time";

interface TableColumnsProps {
    handleEdit?: (data?: any) => void;
    handleCopy?: (data?: any) => void;
    handleUpdateStatus?: (data?: any) => void;
    handleDelete?: (id?: number | string) => void;
}

export const tableColumns = ({
                                 handleEdit = () => {
                                 },
                                 handleCopy = () => {
                                 },
                                 handleDelete = () => {
                                 },
                                 handleUpdateStatus = () => {
                                 },
                             }: TableColumnsProps): SETableColumnsProps[] => [
    {
        id: 'dataCriacao',
        label: 'Data',
        customField: formatDateToBR,
    },
    {
        id: 'administrador',
        label: 'CPF',
        minWidth: 100,
        align: 'left',
        customField: (value) => formatCPF(value.cpf),
    },
    {
        id: 'empreendedor',
        label: 'CNPJ',
        minWidth: 100,
        align: 'left',
        customField: (value) => cnpjMask(value.cnpj),
    },
    {
        id: "status",
        label: "Status",
        align: "center",
        sortable: false,
        width: 320,
        customField: (value: any, row: any) => (
            <Grid container justifyContent="center" alignItems="center">
                <Grid item md={6} container alignItems="center" justifyContent="center">
                    <IconButton onClick={() => handleUpdateStatus(row)}>
                        <>
                            {!row.pendente ? (
                                <RiCheckboxCircleFill
                                    size={26}
                                    color="#66BD91"
                                    title={"Vínculo Aprovado"}
                                />
                            ) : (
                                <RiErrorWarningFill
                                    size={26}
                                    color="#F6E566"
                                    title={"Vínculo Pendente"}
                                />
                            )
                            }
                        </>
                    </IconButton>
                </Grid>
            </Grid>
        ),
    },
];
